import React from 'react';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import { isActiveMemberForSeason } from '../utils/memberStatus';
import './InactiveMemberNotice.css';

const InactiveMemberNotice = () => {
  const { user } = useAuth();
  const { t } = useLanguage();

  if (!user || isActiveMemberForSeason(user)) {
    return null;
  }

  return (
    <div className="inactive-member-notice" role="alert">
      <p>{t('membership.inactiveForSeason')}</p>
    </div>
  );
};

export default InactiveMemberNotice;
